import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AuthorizationInterceptor } from './authorization.interceptor';
import { SKIP_AUTHORIZATION } from './http-context';

/**
 * Functional registration for the existing stateful authorization handler.
 * Token-refresh coordination remains in the injectable handler while request
 * opt-out is expressed through HttpContext.
 */
export const authorizationInterceptorFn: HttpInterceptorFn = (request, next) => {
  if (request.context.get(SKIP_AUTHORIZATION)) {
    return next(request);
  }

  return inject(AuthorizationInterceptor).intercept(request, { handle: next });
};
